<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="unstyled-btns-list">
    <button
        [replaceUrl]="true"
        [routerLink]="['/', { outlets: { popup: 'project-view/bom-report' } }]"
        class="btn btn-link btn-sm btn--bom-report item_row"
    >
        BOM review
    </button>

    <button
        [replaceUrl]="true"
        [routerLink]="['/', { outlets: { popup: 'project-view/bom-summary' } }]"
        class="btn btn-link btn-sm btn-bom-summary item_row"
    >
        BOM summary
    </button>

    <button
        (click)="exportLinkConfig()"
        [disabled]="historyService.logicalTopology.isBomStepDisabled || projectStateService.isBomConfigProject()"
        class="btn btn-link btn-sm btn--export-links-conf item_row"
    >
        Export Link Configuration
    </button>

    <button
        (click)="exportRunnerJson()"
        *ngIf="
            !projectStateService.isBomConfigProject() &&
            !projectStateService.isPotentiallyCorruptedProject() &&
            historyService.logicalTopology.mhTgBuProductsUsed
        "
        class="btn btn-link btn-sm btn--export-json-conf item_row"
    >
        Export Network Configuration File
    </button>
    <button
        (click)="exportLinkSummary()"
        [disabled]="historyService.logicalTopology.isBomStepDisabled || projectStateService.isBomConfigProject()"
        class="btn btn-link btn-sm btn--export-link-summary item_row"
    >
        Export Link Summary
    </button>

    <button
        (click)="exportKmlFile()"
        [disabled]="projectStateService.isBomConfigProject()"
        class="btn btn-link btn-sm btn--export-kml item_row"
    >
        Export Design to KML
    </button>
</div>
